import { Injectable } from '@angular/core';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { Enrollment } from './../models/enrollment';



@Injectable({
    providedIn: 'root'
})

export class EnrollmentService {
    controller = 'Enrollment';

    constructor(private base: BaseService) { }

    gets(): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetAllEnrollments');
    }

    getByCourseId(id: number): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetByCourseId/' + id)
    }

    getByStudentId(id: number): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetByStudentId/' + id)
    }

    enrollment(obj: Enrollment) {
        return this.base.save(this.controller + '/Enrollment', obj);
    }

    getStudentFav(id: number) {
        return this.base.gets(this.controller + '/GetStudentFav/' + id)
    }
}